import { html } from 'lit';

export function renderAppTemplate() {
  return html` <div id="outlet"></div> `;
}
